import styled, { css } from 'styled-components'

interface ISpace {
    top?: string
    bottom?: string
    left?: string
    right?: string
}

export const Space = styled.div<ISpace>`
    ${({ top, bottom, left, right }) => css`
        ${!!top ? `margin-top:${top}px;` : ''}
        ${!!bottom ? `margin-bottom:${bottom}px;` : ''}
        ${!!left ? `margin-left:${left}px;` : ''}
        ${!!right ? `margin-right:${right}px;` : ''}
    `}
`
